import React from 'react';
import { GiftIcon } from 'lucide-react';
export function ProductVisualSection() {
  const bonuses = [{
    label: 'Bonus 1',
    title: 'Guía de Herramientas',
    desc: 'Descubrí exactamente qué herramientas necesitás para empezar sin gastar de más.',
    image: 'https://cdn.magicpatterns.com/uploads/cGJpTmyHPbpqPGVXxewqK8/bonus_1.png',
    alt: 'Bonus 1: Guía de herramientas recomendadas'
  }, {
    label: 'Bonus 2',
    title: 'Los 10 Errores Comunes',
    desc: 'Evitá los errores que te hacen perder clientes cuando recién empezás.',
    image: 'https://cdn.magicpatterns.com/uploads/oittqwoA4ccTaW6GaGFjDn/bonus_2.png',
    alt: 'Bonus 2: Errores más comunes del barbero principiante'
  }, {
    label: 'Bonus 3',
    title: 'Conseguir Clientes',
    desc: 'Estrategias probadas para atraer clientes y generar ingresos desde el día uno.',
    image: 'https://cdn.magicpatterns.com/uploads/9y1VLYc2fxYSx5JzpC7hMJ/bonus_3.png',
    alt: 'Bonus 3: Cómo conseguir clientes y generar ingresos'
  }];
  return <section className="w-full bg-[#0b0b0b] py-16 md:py-24 px-4 relative overflow-hidden border-t border-white/5" data-id="element-300">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#c9a24a]/5 rounded-full blur-3xl pointer-events-none" data-id="element-301"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-302">
        <div className="text-center mb-10 md:mb-16" data-id="element-303">
          <div className="inline-flex items-center justify-center gap-2 bg-[#c9a24a]/10 border border-[#c9a24a]/20 text-[#c9a24a] px-4 py-2 rounded-full text-[10px] md:text-sm font-black uppercase tracking-widest mb-4" data-id="element-304">
            <GiftIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-305" />
            Incluidos gratis
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white leading-tight mb-4" data-id="element-306">
            Además, accedés a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-307">
              3 bonus exclusivos
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-308">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#141418] rounded-xl md:rounded-2xl overflow-hidden border border-white/10 hover:border-[#c9a24a]/30 transition-colors flex flex-row md:flex-col items-center md:items-stretch" data-id="element-309">
              <div className="w-1/3 md:w-full bg-[#0b0b0b] p-3 md:p-6 flex justify-center items-center border-r md:border-r-0 md:border-b border-white/5" data-id="element-310">
                <img src={bonus.image} alt={bonus.alt} className="w-full max-w-[100px] md:max-w-[160px] h-auto object-contain drop-shadow-md" data-id="element-311" />
              </div>
              <div className="w-2/3 md:w-full p-4 md:p-6 flex flex-col justify-center" data-id="element-312">
                <div className="text-[#c9a24a] font-black text-[10px] md:text-xs tracking-widest mb-1 md:mb-2 uppercase" data-id="element-313">
                  {bonus.label}
                </div>
                <h3 className="text-white font-black text-sm md:text-lg mb-1 md:mb-2 leading-tight" data-id="element-314">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed hidden md:block" data-id="element-315">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}